// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-7130a709]{display:none}.social-links[data-v-7130a709]{display:flex;flex-direction:row;justify-content:center;align-items:center}.social-links__link[data-v-7130a709]{display:flex;text-decoration:none}.social-links__link[data-v-7130a709]:not(:last-child){margin-right:6px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
